import { render, staticRenderFns } from "./LikertCreation.vue?vue&type=template&id=55ec348c&scoped=true&"
import script from "./LikertCreation.vue?vue&type=script&lang=js&"
export * from "./LikertCreation.vue?vue&type=script&lang=js&"
import style0 from "./LikertCreation.vue?vue&type=style&index=0&id=55ec348c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec348c",
  null
  
)

export default component.exports